/** Decisión ÚNICA de captura de resultados (rediseño paso 9, Eduardo
 * 2026-07-30): antes eran un toggle y un select separados que podían
 * contradecirse (allow=true + mode=disabled). La UI ofrece dos tarjetas y
 * este helper mantiene ambos campos coherentes. */

export function resultReportingSettings(playersReport: boolean): {
  allow_player_result_reporting: boolean;
  result_reporting_mode: string;
} {
  return {
    allow_player_result_reporting: playersReport,
    result_reporting_mode: playersReport ? "player_report_requires_admin" : "disabled",
  };
}

/** Interpretación de configs existentes, incluidas las contradictorias del
 * modelo viejo: solo cuenta como "los jugadores reportan" si AMBOS campos
 * lo dicen. */
export function playersReportEnabled(settings: {
  allow_player_result_reporting?: boolean | null;
  result_reporting_mode?: string | null;
}): boolean {
  return (
    Boolean(settings.allow_player_result_reporting) &&
    settings.result_reporting_mode !== "disabled"
  );
}
